import React from 'react';
import { withInject } from '@piwikpro/platform';
import {
  Text,
  withTranslation,
  AutoSavedSwitcherControl,
  Stack,
  Card,
} from '@piwikpro/ui-components';
import { TrackerSettings, TrackerSettingsAttributes, TrackerSettingsResponse } from '../../../TrackerSettings';
import FailMessage from '../../GlobalAppSettings/FailMessage';

export interface StripSiteSearchQueryParametersProps {
  settings: TrackerSettingsResponse
  trackerSettings: TrackerSettings
  failed: boolean
  t: (key: string) => string
}

export class StripSiteSearchQueryParameters extends React.Component<
StripSiteSearchQueryParametersProps
> {
  constructor(props: StripSiteSearchQueryParametersProps) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  async handleSubmit(values: Partial<TrackerSettingsAttributes>, {
    setErrors,
    setSubmitting,
    setFieldValue,
  }: any) {
    const { trackerSettings, settings } = this.props;

    try {
      await trackerSettings.updateSettings(values);
    } catch (err: any) {
      setErrors(err.errors);
      setFieldValue(
        'strip_site_search_query_parameters',
        settings.attributes.strip_site_search_query_parameters,
        false,
      );
    }

    setSubmitting(false);
  }

  render() {
    const { settings, failed, t } = this.props;

    return (
      <Card.Section>
        <Stack wrap verticalAlignment="center">
          <Stack.Item fill>
            <Stack vertical spacing="narrow">
              <Stack.Item>
                <Text as="h2" size={20} weight={700} wrapType="noWrapAndCutText" dataId="Header.medium">{t('apps.details.settings.tracking.strip-site-search-query-parameters.title')}</Text>
              </Stack.Item>
              <Stack.Item>
                <Text as="p">{t('apps.details.settings.tracking.strip-site-search-query-parameters.description')}</Text>
              </Stack.Item>
            </Stack>
          </Stack.Item>
          {!failed && (
            <Stack.Item>
              <AutoSavedSwitcherControl
                id="app-settings-tracking-strip-site-search-query-params"
                initialValue={settings.attributes.strip_site_search_query_parameters}
                name="strip_site_search_query_parameters"
                onSubmit={this.handleSubmit}
              />
            </Stack.Item>
          )}
        </Stack>
        {failed && <FailMessage condensed />}
      </Card.Section>
    );
  }
}

export default withInject({
  trackerSettings: 'TrackerSettingsCrate.tracker',
})(withTranslation(['administration'])(StripSiteSearchQueryParameters as any));
